import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAG_VERBUNDPARTNER } from 'src/lib/constants/componentsPath';
import EigenmittelSkizzeEmob, { getFormStrucEigenmittelSkizzeLoewe } from './EigenmittelSkizzeLoewe';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getVerbundPartnerName } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
const P = Schema.attributes;

export const GetEigenmittelSkizzeLoewe = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const orgaName = get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`);
	const OrgaStruc = [
		{
			label: orgaName,
			content: (
				<>
					<EigenmittelSkizzeEmob
						kostentraeger='Antragsteller'
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						institutionsTyp={get(application, P.Organisation_Antragsberechtigt_Als.path)}
						hasComment={hasCommentAusgabenUndFinanzierung}
						selectedOrgaName={orgaName}
					/>
				</>
			),
			formStruc: getFormStrucEigenmittelSkizzeLoewe(application, get(getLocalstorageToken(), 'organisationId')),
		},
	];
	const PartnerStruc = get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
		const orgaName = getVerbundPartnerName(ele, i);
		return {
			label: orgaName,
			content: (
				<EigenmittelSkizzeEmob
					kostentraeger='Verbundpartner'
					unternehmenId={get(ele, 'Verbundpartner.id')}
					institutionsTyp={get(ele, ANTRAG_VERBUNDPARTNER.Antragberechtigt)}
					hasComment={hasCommentAusgabenUndFinanzierung}
					selectedOrgaName={orgaName}
				/>
			),
			formStruc: getFormStrucEigenmittelSkizzeLoewe(application, get(ele, 'Verbundpartner.id')),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
